export const GET_ITEMS = 'SYNONYMS/GET_ITEMS'
export const SET_ITEMS = 'SYNONYMS/SAVE_ITEMS'
